import { QuotationTask, SalesOrderContractTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1661. 受注案件契約タスク計画金額最新化済更新
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:id/update_billing_schedule_checked
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
  billing_schedule_checked: boolean;
};

const updateSalesOrderContractBillingScheduleChecked = (props: Props): Promise<SalesOrderContractTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.id}/update_billing_schedule_checked`,
    props
  );
};

export const useUpdateSalesOrderContractBillingScheduleChecked = () => {
  return useMutation({
    mutationFn: updateSalesOrderContractBillingScheduleChecked,
  });
};
